import { FC } from 'react'
import { TextField } from '@mui/material'
import { useForm } from 'react-hook-form'

interface IFormOfStringProps {
  tempValue: string
  inputError: boolean
  setTempValue: (param: string) => void
}

export const FormOfString: FC<IFormOfStringProps> = ({ tempValue, inputError, setTempValue }) => {
  const { register } = useForm()
  return (
    <TextField
      value={tempValue}
      error={inputError}
      sx={{ background: 'red' }}
      inputProps={{
        style: {
          background: '#F7F7F7',
          border: '1px solid #D4D4D4',
          fontSize: '16px',
          padding: '8px',
        },
      }}
      {...register('text', {
        onChange: (e) => setTempValue(e.target.value),
      })}
    />
  )
}
